@if (hasOnRequest()) {
<div class="budget-onrequest">
  <div>
    <img src="../assets/lib/icons/Icon_Information.svg" alt="Icon_Information" />
    <p>
      <ng-content select="[onRequest]" />
      <span class="action" (click)="openModal.emit(true)"><ng-content select="[onRequest-action]" /></span>
    </p>
  </div>
</div>
}
